// Z-axis depth map for the experience.
// camera (px of scroll) travels forward through these depths.
export const SECTIONS = [
  { id: 'hero', depth: 0, x: '0vw', y: '0vh', noFadeIn: true },
  // 'story' (About) is rendered as a fixed overlay (AboutOverlay) composed around
  // hero2, not as a depth card — it is intentionally absent from this list.
  { id: 'work', depth: 4700, x: '8vw', y: '0vh', rotY: -3, fadeIn: [600, 150] },
  { id: 'social', depth: 7700, x: '-11vw', y: '2vh', rotY: 4, fadeIn: [1700, 1000] },
  { id: 'links', depth: 9500, x: '5vw', y: '3vh', rotY: -2 },
  { id: 'threshold', depth: 11200, x: '0vw', y: '0vh', threshold: true },
  // Finale sections: tight fade-in windows so only one is in focus at a time
  // past the threshold (no blending with the threshold or each other).
  { id: 'tkb', depth: 13100, x: '0vw', y: '0vh', fadeIn: [1000, 500], activeAt: 1100 },
  { id: 'letters', depth: 15200, x: '0vw', y: '0vh', fadeIn: [1000, 500], activeAt: 1100 },
  { id: 'end', depth: 17000, x: '0vw', y: '0vh', fadeIn: [1000, 500], activeAt: 1100, noFadeOut: true },
];

export const THRESHOLD_DEPTH = 11200;
export const MAX_CAM = 17250;

// Shared mutable state — written by the active experience, read by
// particles / atmosphere / cursor systems every frame. No React re-renders.
export const scrollState = {
  camera: 0,
  blend: 0, // 0 = creator world, 1 = fantasy world
  progress: 0,
};

export const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

export const smoothstep = (a, b, v) => {
  const t = clamp((v - a) / (b - a), 0, 1);
  return t * t * (3 - 2 * t);
};
